import React from 'react';
import classnames from 'classnames';
import {Link} from '@reach/router';

import * as styles from './NavLink.module.css';

export function NavLink({children, ...props}) {
  return (
    <Link
      {...props}
      getProps={({isCurrent}) => {
        return {
          className: classnames(styles.NavLink, {
            [styles['NavLink-Active']]: isCurrent,
          }),
        };
      }}
    >
      {children}
    </Link>
  );
}
